import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { QUERY_KEYS } from '@/api/queryKeys';
import {
  previewImport,
  executeImport,
  type ImportFileType,
  type ConflictStrategy,
} from '@/api/import.api';
import { ApiError } from '@/api/client';

// ─── Vorschau (Preview) ────────────────────────────────────────────────────

export function useImportPreview() {
  return useMutation({
    mutationFn: ({ file, fileType }: { file: File; fileType: ImportFileType }) =>
      previewImport(file, fileType),
    onError: (error: ApiError) => {
      toast.error(error.message || 'Datei konnte nicht gelesen werden.');
    },
  });
}

// ─── Import ────────────────────────────────────────────────────────────────

export function useExecuteImport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      file,
      fileType,
      strategy,
    }: {
      file: File;
      fileType: ImportFileType;
      strategy: ConflictStrategy;
    }) => executeImport(file, fileType, strategy),
    onSuccess: (report) => {
      // Alle relevanten Caches invalidieren
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.persons.all });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.tree.all });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.relationships.all });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.familyMembers.all });

      toast.success(`${report.imported} Personen importiert.`);
    },
    onError: (error: ApiError) => {
      toast.error(error.message || 'Import fehlgeschlagen.');
    },
  });
}
